import { Component } from "react";
import "./manager-home.scss";

class AnalyticsHome extends Component {
  render() {
    return (
      <div className="analyticsHome">
        analytics home
      </div>
    );
  }
}

export default AnalyticsHome;